import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { UpdateAppointmentHistoryDetails } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { HistoryStatus, HistoryStatusId } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Component({
  selector: 'app-appointment-update',
  templateUrl: './appointment-update.component.html'
})
export class AppointmentUpdateComponent implements OnInit {
  showFiller = false;
  currentIndex:number;
  appointmentId:number;
  updateAppointmentHistory:UpdateAppointmentHistoryDetails[]=[]
  historyNameSearchTerm: string = '';
  constructor(
    private readonly editAppointmentService: EditAppointmentService,
    private readonly appointmentService: AppointmentService,
    private readonly spinner: NgxSpinnerService,
    private readonly activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.appointmentId = this.editAppointmentService.appointmentDetails.id;
    this.getDeatils();
  }
  getDeatils(){
    this.spinner.show();
    this.appointmentService.GetUpdateAppointmentHistory(this.appointmentId).then((response)=>{
      if(response.responseObject?.errorCount === undefined || response.responseObject?.length > 0){
        this.updateAppointmentHistory = response.responseObject;
        if(this.updateAppointmentHistory?.length>0){
          this.updateAppointmentHistory.forEach((x,index)=>{
            x.type = this.getType(x.typeId,x.details);
            x.rowId = (this.updateAppointmentHistory.length - (index));
            x.createdDate = Utility.ConvertUTCDateToLocalDate(x.createdDate);
            if (((typeof x.userName === "string" && x.userName.trim().length == 0) || x.userName === null) && (this.isDMS(x.typeId))) {
              // It is an empty string
              x.userName = "DMS";
           }
           else if(((typeof x.userName === "string" && x.userName.trim().length == 0) || x.userName === null) && (x.applicationName == 'CheckIn' || x.applicationName == 'StatusTracker' || x.applicationName == 'Widget')){
              x.userName = "Customer";
           }
           else if((typeof x.userName === "string" && x.userName.trim().length == 0) || x.userName === null){
            x.userName = "-";
           }
           if(this.isEvent(x.typeId))
           {
             x.eventType = "Event"
           }
           else{
            x.eventType = "Record Updated"
           }
          })
        }
      }
      this.spinner.hide();
    })
  }

  get filteredUpdateAppointmentHistory(): UpdateAppointmentHistoryDetails[] {
    const normalizedSearchTerm = this.historyNameSearchTerm.trim().toLowerCase();

    if (!normalizedSearchTerm) {
      return this.updateAppointmentHistory;
    }

    return this.updateAppointmentHistory.filter((historyItem: UpdateAppointmentHistoryDetails) =>
      (historyItem.type || '').toLowerCase().includes(normalizedSearchTerm)
      || String(historyItem.details || '').toLowerCase().includes(normalizedSearchTerm)
    );
  }

  toDisplayText(value: any): string {
    return value === null || value === undefined ? '' : String(value);
  }
  
  getType(key: number, value:any = null): string {
    switch (key) {
      case HistoryStatusId.AddAppointment:
        return HistoryStatus.AddAppointment;
      case HistoryStatusId.UpdateAppointment:
        return HistoryStatus.UpdateAppointment;
      case HistoryStatusId.AddMechanic:
        return HistoryStatus.AddMechanic;
      case  HistoryStatusId.UpdateMechanic:
        return HistoryStatus.UpdateMechanic;
      case HistoryStatusId.AddAdditionalWork:
        return HistoryStatus.AddAdditionalWork;
      case HistoryStatusId.MechanicStarted:
        return HistoryStatus.MechanicStarted;
      case HistoryStatusId.MechanicDone:
        return HistoryStatus.MechanicDone;
      case HistoryStatusId.WorkDone:
        return HistoryStatus.WorkDone;
      case HistoryStatusId.DeleteMechanic:
        return HistoryStatus.DeleteMechanic;
      case HistoryStatusId.AddAppoitmentFromWidget:
        return HistoryStatus.AddAppoitmentFromWidget;
      case HistoryStatusId.ApprovedByServiceAdvisor:
        return HistoryStatus.ApprovedByServiceAdvisor;
      case HistoryStatusId.CheckListAnswer:
        return HistoryStatus.CheckListAnswer;
      case HistoryStatusId.UpdateMileage:
        return HistoryStatus.UpdateMileage;
      case HistoryStatusId.AppoitmentStartJobTimer:
        return HistoryStatus.AppoitmentStartJobTimer;
      case HistoryStatusId.AppoitmentStopJobTimer:
        return HistoryStatus.AppoitmentStopJobTimer;
      case HistoryStatusId.AdditionalWorkApprovedByCustomer:
        return HistoryStatus.AdditionalWorkApprovedByCustomer;
      case HistoryStatusId.AdditionalWorkRejectByCustomer:
        return HistoryStatus.AdditionalWorkRejectByCustomer;
      case HistoryStatusId.VirtualCheckInDoneByCustomer:
        return HistoryStatus.VirtualCheckInDoneByCustomer;
      case HistoryStatusId.CheckInSMSSent:
        return HistoryStatus.CheckInSMSSent;
      case HistoryStatusId.TrackerSMSSent:
        return HistoryStatus.TrackerSMSSent;
      case HistoryStatusId.PaymentDone:
        return HistoryStatus.PaymentDone;
      case HistoryStatusId.ImportFromSSM:
        return HistoryStatus.ImportFromSSM;
      case HistoryStatusId.SSMSentVin:
        return HistoryStatus.SSMSentVin;
      case HistoryStatusId.WarrantyDocumentSendToSign:
        return HistoryStatus.WarrantyDocumentSendToSign;
      case HistoryStatusId.WarrantyDocumentSigned:
        return HistoryStatus.WarrantyDocumentSigned;
      case HistoryStatusId.WarrantyDocumentRejected:
        return HistoryStatus.WarrantyDocumentRejected;
      case HistoryStatusId.CustomerKeyPickUp:
        return HistoryStatus.CustomerKeyPickUp;
      case HistoryStatusId.CustomerKeyDrop:
        return HistoryStatus.CustomerKeyDrop;
      case HistoryStatusId.MechanicKeyDrop:
        return HistoryStatus.MechanicKeyDrop;
      case HistoryStatusId.MechanicKeyPickUp:
        return HistoryStatus.MechanicKeyPickUp;
      case HistoryStatusId.MechanicKeyReset:
        return HistoryStatus.MechanicKeyReset;
      case HistoryStatusId.DMSAddAppoitment:
        return HistoryStatus.DMSAddAppoitment;
      case HistoryStatusId.DMSUpdateAppointment:
        return HistoryStatus.DMSUpdateAppointment;
      case HistoryStatusId.DMSAppoitmentDeleted:
        return HistoryStatus.DMSAppoitmentDeleted;
      case HistoryStatusId.DMSServiceLineDeleted:
        return HistoryStatus.DMSServiceLineDeleted;
      case HistoryStatusId.DMSAddDemand:
        return HistoryStatus.DMSAddDemand;
      case HistoryStatusId.DMSEditDemand:
        return HistoryStatus.DMSEditDemand;
      case HistoryStatusId.DMSDeleteDemand:
        return HistoryStatus.DMSDeleteDemand;
      case HistoryStatusId.DMSAddJobDetails:
        return HistoryStatus.DMSAddJobDetails;
      case HistoryStatusId.DMSEditJobDetails:
        return HistoryStatus.DMSEditJobDetails;
      case HistoryStatusId.DMSDeleteJobDetails:
        return HistoryStatus.DMSDeleteJobDetails;
      case HistoryStatusId.ShiftAppointment:
        return HistoryStatus.ShiftAppointment;
      case HistoryStatusId.ImportFromRomnas:
          return HistoryStatus.ImportFromRomnas;
      case HistoryStatusId.ImportFromTecRMI:
          return HistoryStatus.ImportFromTecRMI;

      case HistoryStatusId.WaitingFromCustomer:
        return HistoryStatus.WaitingFromCustomer;
      case HistoryStatusId.CarArrived:
        return HistoryStatus.CarArrived;

      case HistoryStatusId.AppoitmentStartWOTimer:
        return HistoryStatus.AppoitmentStartWOTimer;
      
      case HistoryStatusId.AppoitmentStopWOTimer:
        return HistoryStatus.AppoitmentStopWOTimer;
    
      case HistoryStatusId.AppointmentDemandComment:
        return HistoryStatus.AppointmentDemandComment;

      case HistoryStatusId.ParkingImageSaved:
        return HistoryStatus.ParkingImageSaved;

      case HistoryStatusId.InternalCommentSaved:
        return HistoryStatus.InternalCommentSaved;

       case HistoryStatusId.DemandFileUpload:
        return HistoryStatus.DemandFileUpload;

      case HistoryStatusId.ChecklistFileUpload:
        return HistoryStatus.ChecklistFileUpload;

      case HistoryStatusId.AdditionalWorkFileUpload:
        return HistoryStatus.AdditionalWorkFileUpload;

      case HistoryStatusId.DiagnoseCheckListFileUpload:
        return HistoryStatus.DiagnoseCheckListFileUpload;

      case HistoryStatusId.DemandFileDeleted:
        return HistoryStatus.DemandFileDeleted;
  
      case HistoryStatusId.ChecklistFileDeleted:
        return HistoryStatus.ChecklistFileDeleted;
  
      case HistoryStatusId.AdditionalWorkFileDeleted:
        return HistoryStatus.AdditionalWorkFileDeleted;
  
      case HistoryStatusId.DiagnoseCheckListFileDeleted:
        return HistoryStatus.DiagnoseCheckListFileDeleted;

      case HistoryStatusId.OnHold:
        return HistoryStatus.OnHold;

      case HistoryStatusId.DiagnoseCheckListAnswer:
        return HistoryStatus.DiagnoseCheckListAnswer;

        case HistoryStatusId.ParkingImageDeleted:
          return HistoryStatus.ParkingImageDeleted;

      case HistoryStatusId.AdditionalWorkAddDemand:
        return HistoryStatus.AdditionalWorkAddDemand;
      case HistoryStatusId.AdditionalWorkDeleteDemand:
        return HistoryStatus.AdditionalWorkDeleteDemand;
      case HistoryStatusId.AdditionalWorkAddJobDetails:
        return HistoryStatus.AdditionalWorkAddJobDetails;
      case HistoryStatusId.AdditionalWorkDeleteJobDetails:
        return HistoryStatus.AdditionalWorkDeleteJobDetails;
      case HistoryStatusId.CustomerUploadedDocument:
          return HistoryStatus.CustomerUploadedDocument;
      case HistoryStatusId.AddDemand:
        return HistoryStatus.AddDemand;
      case HistoryStatusId.DeleteDemand:
        return HistoryStatus.DeleteDemand;
      case HistoryStatusId.AddJobDetails:
        return HistoryStatus.AddJobDetails;
      case HistoryStatusId.DeleteJobDetails:
        return HistoryStatus.DeleteJobDetails;
      case HistoryStatusId.RentalCarUpdated:
        return HistoryStatus.RentalCarUpdated;
      case HistoryStatusId.WorkOrderStatusUpdated:
        return HistoryStatus.WorkOrderStatusUpdated;
      case HistoryStatusId.MileageUpdated:
        return HistoryStatus.MileageUpdated;
      case HistoryStatusId.IsCustomerWaitingUpdated:
        return HistoryStatus.IsCustomerWaitingUpdated;
      case HistoryStatusId.DeliveryTimeUpdated:
        return HistoryStatus.DeliveryTimeUpdated;
      case HistoryStatusId.FinishTimeUpdated:
        return HistoryStatus.FinishTimeUpdated;
      case HistoryStatusId.InternalCommentAdded:
        return HistoryStatus.InternalCommentAdded;
      case HistoryStatusId.UpdateJobStatus:
        return HistoryStatus.UpdateJobStatus;
      case HistoryStatusId.WorkorderTimeCorrection:
        return HistoryStatus.WorkorderTimeCorrection;
      case HistoryStatusId.JobTimeCorrection:
        return HistoryStatus.JobTimeCorrection;
      case HistoryStatusId.DeletedTimeSummry:
        return HistoryStatus.DeletedTimeSummry;
      case HistoryStatusId.InvoiceGenerated:
        return HistoryStatus.InvoiceGenerated;
      case HistoryStatusId.AppoitmentStartJobDetailTimer:
        return HistoryStatus.AppoitmentStartJobDetailTimer;
      case HistoryStatusId.AppoitmentStopJobDetailTimer:
        return HistoryStatus.AppoitmentStopJobDetailTimer;  
      case HistoryStatusId.JobDetailTimeCorrection:
        return HistoryStatus.JobDetailTimeCorrection;
      case HistoryStatusId.ContactNameUpdated:
        return HistoryStatus.ContactNameUpdated;
      case HistoryStatusId.ContactNumberUpdated:
        return HistoryStatus.ContactNumberUpdated;
      case HistoryStatusId.AppointmentDeleted:
        return HistoryStatus.AppointmentDeleted;
      case HistoryStatusId.PlanningDeletedOnCancelStatus:
        return HistoryStatus.PlanningDeletedOnCancelStatus;
      case HistoryStatusId.InternalCommentUpdated:
        return HistoryStatus.InternalCommentUpdated;
      case HistoryStatusId.ImportSstRequest:
        return HistoryStatus.ImportSstRequest;
      case HistoryStatusId.ExportSstRequest:
        return HistoryStatus.ExportSstRequest;
      case HistoryStatusId.TechnicianUpdatedIntoSst:
        return HistoryStatus.TechnicianUpdatedIntoSst;
      case HistoryStatusId.TechnicianDeletedIntoSst:
        return HistoryStatus.TechnicianDeletedIntoSst;
      case HistoryStatusId.DemandStatusUpdatedIntoSst:
        return HistoryStatus.DemandStatusUpdatedIntoSst;  
      case HistoryStatusId.InformationUpdated:
        return HistoryStatus.InformationUpdated;
      case HistoryStatusId.CampaignServiceUpdated:
        return HistoryStatus.CampaignServiceUpdated;
      case HistoryStatusId.MediaVisibilityUpdated:
        return HistoryStatus.MediaVisibilityUpdated;
      case HistoryStatusId.ShareBoxInformationSent:
        return HistoryStatus.ShareBoxInformationSent;
      case HistoryStatusId.CustomerDropTimeUpdated:
        return HistoryStatus.CustomerDropTimeUpdated;
      case HistoryStatusId.CustomerPickupTimeUpdated:
        return HistoryStatus.CustomerPickupTimeUpdated;
      case HistoryStatusId.CreateOfferInMPO:
        return HistoryStatus.CreateOfferInMPO;
      case HistoryStatusId.GetOfferFromMPO:
        return HistoryStatus.GetOfferFromMPO;
      case HistoryStatusId.DemandSentForCustomerApproval:
        return HistoryStatus.DemandSentForCustomerApproval;
      case HistoryStatusId.AFXDemandSyncToSST:
        return HistoryStatus.AFXDemandSyncToSST;
      case HistoryStatusId.WidgetAppointmentRequest:
        return HistoryStatus.WidgetAppointmentRequest;
      case HistoryStatusId.KeyPickupWithoutPayment:
        return HistoryStatus.KeyPickupWithoutPayment;
      case HistoryStatusId.CustomerUpdated:
        return HistoryStatus.CustomerUpdated;
      case HistoryStatusId.DiscountCodeUpdated:
        return HistoryStatus.DiscountCodeUpdated;
      case HistoryStatusId.DSODiagnoseUpdate:
        return HistoryStatus.DSODiagnoseUpdate;
      case HistoryStatusId.serviceAdvisorUpdated:
        return HistoryStatus.serviceAdvisorUpdated;
      case HistoryStatusId.DocumentPartStatusUpdated:
        return HistoryStatus.DocumentPartStatusUpdated;
      case HistoryStatusId.AppointmentAuthorizedStatusUpdated:
        return `${HistoryStatus.AppointmentAuthorizedStatusUpdated} - ${value}`;
      case HistoryStatusId.AppointmentCreatedFromQuote:
        return `${HistoryStatus.AppointmentCreatedFromQuote} ${value}`;
      case HistoryStatusId.CreatedQuoteFromDemands:
        return `${HistoryStatus.CreatedQuoteFromDemands}: ${value.split(' - ')[0] || ''}`;
      case HistoryStatusId.ReOpenAppointmentFromArchive:
        return HistoryStatus.ReOpenAppointmentFromArchive;
      case HistoryStatusId.QuoteReOpenedSuccessfully:
        return HistoryStatus.QuoteReOpenedSuccessfully;
      case HistoryStatusId.SellToCustomerUpdated:
        return HistoryStatus.SellToCustomerUpdated;
      case HistoryStatusId.BillToCustomerUpdated:
        return HistoryStatus.BillToCustomerUpdated;
      default:
        return "";
    }
  }
  isEvent(typeId):boolean{
           return ((typeId === HistoryStatusId.MechanicStarted) 
           || (typeId === HistoryStatusId.MechanicDone) 
           || (typeId === HistoryStatusId.WorkDone) 
           || (typeId === HistoryStatusId.CheckListAnswer) 
           || ( typeId === HistoryStatusId.VirtualCheckInDoneByCustomer) 
           || (typeId === HistoryStatusId.CheckInSMSSent ) 
           || ( typeId === HistoryStatusId.TrackerSMSSent) 
           || (typeId === HistoryStatusId.ImportFromSSM) 
           || (typeId === HistoryStatusId.SSMSentVin)
           || (typeId === HistoryStatusId.WarrantyDocumentSendToSign)
           || (typeId === HistoryStatusId.WarrantyDocumentSigned)
           || (typeId === HistoryStatusId.WarrantyDocumentRejected)
           || (typeId === HistoryStatusId.DMSAddAppoitment)
           || (typeId === HistoryStatusId.DMSUpdateAppointment)
           || (typeId === HistoryStatusId.DMSAppoitmentDeleted)
           || (typeId === HistoryStatusId.DMSServiceLineDeleted)
           || (typeId === HistoryStatusId.DMSAddDemand)
           || (typeId === HistoryStatusId.DMSEditDemand)
           || (typeId === HistoryStatusId.DMSDeleteDemand)
           || (typeId === HistoryStatusId.DMSAddJobDetails)
           || (typeId === HistoryStatusId.DMSEditJobDetails)
           || (typeId === HistoryStatusId.DMSDeleteJobDetails)
           || (typeId === HistoryStatusId.ImportFromRomnas)
           || (typeId === HistoryStatusId.ImportFromTecRMI)
           || (typeId === HistoryStatusId.CarArrived)
           || (typeId === HistoryStatusId.OnHold)
           || (typeId === HistoryStatusId.AppoitmentStartWOTimer)
           || (typeId === HistoryStatusId.AppoitmentStopWOTimer)
           || (typeId === HistoryStatusId.DiagnoseCheckListAnswer)
           || (typeId === HistoryStatusId.ParkingImageSaved)
           || (typeId === HistoryStatusId.DemandFileUpload)
           || (typeId === HistoryStatusId.DemandFileDeleted)
           || (typeId === HistoryStatusId.AdditionalWorkFileUpload)
           || (typeId === HistoryStatusId.AdditionalWorkFileDeleted)
           || (typeId === HistoryStatusId.ChecklistFileUpload)
           || (typeId === HistoryStatusId.ChecklistFileDeleted)
           || (typeId === HistoryStatusId.DiagnoseCheckListFileUpload)
           || (typeId === HistoryStatusId.DiagnoseCheckListFileDeleted)
           || (typeId === HistoryStatusId.ParkingImageDeleted)
           || (typeId === HistoryStatusId.CustomerUploadedDocument)
           || (typeId === HistoryStatusId.IsCustomerWaitingUpdated)
           || (typeId === HistoryStatusId.DeliveryTimeUpdated)
           || (typeId === HistoryStatusId.FinishTimeUpdated)
           || (typeId === HistoryStatusId.RentalCarUpdated)
           || (typeId === HistoryStatusId.InvoiceGenerated)
           || (typeId === HistoryStatusId.ContactNameUpdated)
           || (typeId === HistoryStatusId.InformationUpdated)
           || (typeId === HistoryStatusId.ContactNumberUpdated)
           || (typeId === HistoryStatusId.AppointmentDeleted)
           || (typeId === HistoryStatusId.PlanningDeletedOnCancelStatus)
           || (typeId === HistoryStatusId.ImportSstRequest)
           || (typeId === HistoryStatusId.ExportSstRequest)
           || (typeId === HistoryStatusId.TechnicianUpdatedIntoSst)
           || (typeId === HistoryStatusId.TechnicianDeletedIntoSst)
           || (typeId === HistoryStatusId.ShareBoxInformationSent)
           || (typeId === HistoryStatusId.DemandStatusUpdatedIntoSst)
           || (typeId === HistoryStatusId.ShareBoxInformationSent)
           || (typeId === HistoryStatusId.CreateOfferInMPO)
           || (typeId === HistoryStatusId.GetOfferFromMPO)
           || (typeId === HistoryStatusId.DemandSentForCustomerApproval)
           || (typeId === HistoryStatusId.AppointmentAuthorizedStatusUpdated)
           || (typeId === HistoryStatusId.AppointmentCreatedFromQuote)
           || (typeId === HistoryStatusId.ReOpenAppointmentFromArchive)
           || (typeId === HistoryStatusId.QuoteReOpenedSuccessfully)
           )
  }
  isDMS(typeId):boolean{
    return ((typeId === HistoryStatusId.DMSAddAppoitment)
    || (typeId === HistoryStatusId.DMSUpdateAppointment)
    || (typeId === HistoryStatusId.DMSAppoitmentDeleted)
    || (typeId === HistoryStatusId.DMSServiceLineDeleted) 
    || (typeId === HistoryStatusId.DMSAddDemand)
    || (typeId === HistoryStatusId.DMSEditDemand)
    || (typeId === HistoryStatusId.DMSDeleteDemand)
    || (typeId === HistoryStatusId.DMSAddJobDetails)
    || (typeId === HistoryStatusId.DMSEditJobDetails)
    || (typeId === HistoryStatusId.DMSDeleteJobDetails))
  }
  OnClose(){
    this.activeModal.close({success: false});
  }

}
